export default "__VITE_ASSET__f0KVH$Uh__"